import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { ClearAfterUnmountWrapper, TextInput, EnumDropdown } from 'framework/form';
import { PositionDropdown, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';
import { TeamSlotDropdown } from 'domain/shared/newProject';
import { TechnologyDropdown } from 'domain/shared/career';
import useAssignmentMembership from 'domain/shared/assignment/createupdate/useAssignmentMembership';
import { isIndividualAssignment } from 'domain/shared/assignment/createupdate/useAssignmentFormState';

const EmployeeAssignmentMembershipInfo = ({ isCreateForm }: { isCreateForm?: boolean }) => {
  const { showTeamMembershipFields, teamResponse, projectRolesForDropdown } = useAssignmentMembership(isCreateForm);
  if (!showTeamMembershipFields) {
    return null;
  }

  return (
    <>
      <FormSection title="Membership information">
        <FormRow>
          <ClearAfterUnmountWrapper isVisible={isIndividualAssignment}>
            <PositionDropdown source="positionId" label="Position" disabled />
          </ClearAfterUnmountWrapper>
          <ClearAfterUnmountWrapper isVisible={assignment => Number(assignment.positionId) === SOFTWARE_ENGINEER_ID}>
            <TechnologyDropdown source="technologyId" label="Technology" disabled />
          </ClearAfterUnmountWrapper>
          <EnumDropdown
            options={EMPLOYEE_COMPETENCY_LEVEL}
            source="competencyLevel"
            label="Competency level"
            disabled
          />
          <EnumDropdown options={projectRolesForDropdown} source="membershipRole" label="Membership role" disabled />
          <TeamSlotDropdown source="slotId" projectIdSource="target.id" label="Slot" team={teamResponse ?? undefined} />
        </FormRow>
        <BigFormRow>
          <TextInput source="noteText" label="Note" />
        </BigFormRow>
      </FormSection>
    </>
  );
};

export default EmployeeAssignmentMembershipInfo;
